module.exports = __webpack_public_path__ + "img/Avatar-81.988f6aa3.svg";